
import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MustMatch } from '../../helpers/must-match.validator';
import { UserService } from 'src/app/services/user.service';
import { catchError, debounceTime, debounce, map } from 'rxjs/operators';
import { throwError, from, Subject, Observable } from 'rxjs';
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { getLocalTranslate } from 'src/app/helpers/global-functions'
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-fb-register',
  templateUrl: './fb-register.component.html',
  styleUrls: ['./fb-register.component.css']
})
export class FbRegisterComponent implements OnInit {

  @ViewChild('selectSex') selectSex:ElementRef;

  public showSpinner: boolean;

  registerForm: FormGroup;

  subject = new Subject<string>()

  isUserExist:boolean = false

  isCheckingUser:boolean = false

  newAccount:string = 'Create new Account'
  signedUp:string = 'Already signed up?'
  login:string = 'Login'
  nameText:string = 'Name'
  sexText:string = 'Sex'
  male:string = 'Male'
  female:string = 'Female'
  dobText:string = 'Date of Birth'
  phoneText:string = 'Phone'
  emailForLogin:string = 'Email'
  passwordText:string = 'Password'
  repeatPasswordText:string = 'Repeat password'
  signUp:string = 'Sign Up'

  emailValue:string = ''
  phoneValue:string = ''

  constructor(
    private formBuiler: FormBuilder,
    private service: UserService,
    private zone:NgZone,
    private router: Router,
    private toastr: ToastrService,
    private authService:AuthService
  ) { }

  ngOnInit() {
    this.authService.checkAuth().then(result=>{
      this.name.setValue(result.displayName)
      this.phoneNumber.setValue(result.phoneNumber)
      this.email.setValue(result.email)
      this.emailValue = result.email
      this.phoneValue = result.phoneNumber
    })
    //this.needTranslate()
    this.registerForm = this.formBuiler.group(
      {
        name: new FormControl('', [
          Validators.required
        ]),
        email: new FormControl('', [
          Validators.required,
          Validators.email
        ]),
        phoneNumber: new FormControl('', [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(9)
        ]),
        dob: new FormControl('',
         Validators.required
        ),
        sex: new FormControl(''
        )
      }, {
      validators: [
      ],
    });

    this.handleEmailTypingObserver();
  }

  needTranslate(){
    this.newAccount  = getLocalTranslate('new-account',this.newAccount)
    this.signedUp = getLocalTranslate('signed-up',this.signedUp)
    this.login = getLocalTranslate('login',this.login)
    this.nameText = getLocalTranslate('name',this.nameText)
    this.sexText = getLocalTranslate('sex',this.sexText)
    this.male = getLocalTranslate('male',this.male)
    this.female = getLocalTranslate('female',this.female)
    this.phoneText = getLocalTranslate('phone',this.phoneText)
    this.emailForLogin = getLocalTranslate('email-for-login',this.emailForLogin)
    this.passwordText = getLocalTranslate('password',this.passwordText)
    this.repeatPasswordText = getLocalTranslate('repeat-password',this.repeatPasswordText)
    this.signUp = getLocalTranslate('sign-up',this.signUp)
    this.dobText = getLocalTranslate('dob',this.dobText)
  }

  handleEmailTypingObserver(){
    this.subject.pipe(
      debounceTime(1000),
      map(searchText => {
        return searchText
      })
    ).subscribe(result=>{
      this.isUserExist = false
      if (this.email.invalid){
        return
      }
      this.isCheckingUser = true
      this.service.checkExistUser(result).subscribe(status=>{
        this.isCheckingUser = false
        this.isUserExist = status
      })
    })
    
  } 

  get name() { return this.registerForm.get('name') };
  get dob() { return this.registerForm.get('dob') };
  get sex() { return this.registerForm.get('sex') };
  get email() { return this.registerForm.get('email') };
  get phoneNumber() { return this.registerForm.get('phoneNumber') };

  onSubmit() {
    var sex = this.selectSex.nativeElement.value;
    if(sex == ""){
      this.toastr.error("Please choose sex");
      return;
    }
    sex = parseInt(sex);
    if (this.registerForm.valid) {
      let name = this.name.value;
      let email = this.email.value;
      let phoneNumber = this.phoneNumber.value;
      let dob = this.dob.value;
      this.showSpinner = true;
      this.service.registerFB(name, email,phoneNumber,dob,sex)
        .pipe(
          catchError(this.handleError)
        )
        .subscribe(
          result => {
            console.log(result);
            this.showSpinner = false;
            this.toastr.success('Updated Successfully');
            this.zone.run(()=>{
              this.router.navigate(['my-account/courses']);
            });
          },
          error => {
            this.showSpinner = false;
            this.toastr.error(error);
          }
        );
    }
  }

  handleError(error: HttpErrorResponse) {
    let message = "Register failed";
    return throwError("Register failed");
  }

  onKeyPressEvent(evt: KeyboardEvent) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if(charCode === 48 && this.phoneNumber.value === ''){
      return false;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onEmailTextFieldKeyUp(event){
    this.subject.next(event.target.value);
  }

  changeSex(e) {
    this.sex.setValue(e.target.value, {
      onlySelf: true
    })
  }

}
